import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    fill: "none",
    viewBox: "0 0 7 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1493FF",
    d: "M4 11.5V2.707l2.147 2.146a.5.5 0 0 0 .707-.708l-3-3a.496.496 0 0 0-.708 0l-2.998 3a.5.5 0 0 0 .707.707L3 2.706V11.5a.5.5 0 0 0 1 0"
  })));
};

export { SvgArrowUp as default };
//# sourceMappingURL=arrow-up.svg.js.map
